import { React, useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  AutoComplete,
  Tooltip,
} from "antd";
import { Collapse } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DisabledButtonStyle, Styled, StyledTab } from "../../pageStyled";
import { newUploadOrders, uploadPODocuments } from "../../../Services/uploadServices";
import { DatePicker } from "antd";
import {
  DatePickerY,
  GlobalSet,
  DisabledStyles,
  DeliveryaddressSpacing,
} from "../../pageStyled";
import {
  addPo,
  postOrder,
  getPackagingList,
  addSo,
} from "../../../Services/orderServices";
import { Country, State } from "country-state-city";
import moment from "moment";
import {
  getProductDetails,
  getProductsData,
  getProducts,
} from "../../../Services/productServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { BackTop } from "antd";
import {
  getMachineGradeSelect,
  getReelCoreValues,
} from "../../../Services/settingsServices";
import { getCustomerDetails } from "../../../Services/customerServices";
import { getMachineGradeSelectForConfig } from "../../../Services/settingsServices";
import Multiselect from "multiselect-react-dropdown";
import styled from "styled-components";
import {
  lengthUnit,
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
  CoversionFactorCMToUnits,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import { useNavigate, useLocation } from "react-router-dom";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getImageURL } from "../../../Services/deckleMatchServices";
const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "2px solid #dfe1e6",
    "border-radius": "8px",
    width: "332px",
    "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
    width: 332px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;

const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const rewinderType = [
  { label: "Constant", value: "constant" },
  { label: "Range", value: "range" },
];
const plyData = [
  { label: "Single Ply", value: 1 },
  { label: "Double Ply", value: 2 },
  { label: "3-Ply", value: 3 },
  { label: "4-Ply", value: 4 },
];
const { TextArea } = Input;
const { Panel } = Collapse;

const AddDummyOrderDrawer = (props) => {
  const scrollRef = useRef(null);
  const history = useNavigate();
  const [form] = Form.useForm();
  let soNo = "";
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [products, setProducts] = useState([]);
  const [cities, setCities] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedPly, setSelectedPly] = useState(1);
  const [orderQuantityTabArray, setOrderQuantityTabArray] = useState([]);
  const [orderQuantity, setOrderQuantity] = useState("weight");
  const [outerDiameter, setOuterDiameter] = useState("constant");
  const [isStateDropdownOpen, setStateDropdown] = useState(false);
  const [isProductDropdownOpen, setProductDropdown] = useState(false);
  const [isPlyDropdownOpen, setPlyDropdown] = useState(false);
  const [isCountryDropdownOpen, setCountryDropdown] = useState(false);
  const [isCurrencyDropdownOpen, setCurrencyDropdown] = useState(false);
  const [productData, setProductData] = useState();
  const [mixedGrain, setMixedGrain] = useState(false);
  const [grainChanges, setGrainChanges] = useState(true);
  const [isMixedGrainEnabled, setMixedGrainEnabled] = useState(false);
  const [isToleranceDisabled, setToleranceDisabled] = useState(false);
  const [defaultUpperOrderTol, setDefaultUpperOrderTol] = useState("");
  const [defaultLowerOrderTol, setDefaultLowerOrderTol] = useState("");
  const [orderUpperTol, setOrderUpperTol] = useState("");
  const [orderLowerTol, setOrderLowerTol] = useState("");
  const [coreOD, setCoreod] = useState("");
  const [reelOD, setReelod] = useState("");
  const [grainValue, setGrain] = useState("");
  const [lengthValue, setLength] = useState("");
  const [widthValue, setWidth] = useState("");
  const [weightValue, setWeight] = useState("");
  const [quantityValue, setQuantity] = useState("");
  const [measurementData, setMeasurementData] = useState();
  const [dimesionUnitList, setDimesionUnitList] = useState([]);
  const [weightUnitList, setWeightUnitList] = useState([]);
  const [currencyUnitData, setCurrencyUnitData] = useState([]);
  const [sizeToleUnitPlaceholder, setSizeToleUnitPlaceholder] = useState("cm");
  const [unitPlaceholder, setUnitPlaceholder] = useState("");
  const [netPrice, setNetPrice] = useState("");
  const [netPriceSymbol, setNetPriceSymbol] = useState("");
  const [packagingData, setPackagingData] = useState([]);
  const [checkedBox, setCheckedBox] = useState(true);
  const [selectedPackaging, setSelectedPackaging] = useState("");
  const [planningWeightValue, setPlanningWeightValue] = useState("");
  const [planningQuantityValue, setPlanningQuantityValue] = useState("");
  const [planningWtErr, setPlanningWtErr] = useState(false);
  const [reelCoreData, setReelCoreData] = useState();
  const [reelValues, setReelvalues] = useState();
  const [coreValues, setCoreValues] = useState();
  const [selectedReelOD, setSelectedReelOD] = useState();
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const [rangeValidationError, setRangeValidationError] = useState(false);
  const [plannedReels, setPlannedReels] = useState(0);
  const [plannedWeight, setPlannedWeight] = useState(0);
  const [rerender, setRerender] = useState(false);
  const [add, setAdd] = useState(false);
  const [widthUnit, setWidthUnit] = useState();
  const [dealerPriceValue, setDealerPriceValue] = useState();
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const fieldBlacklist =
    settingsData?.settings?.orders_page?.side_drawers?.dummy_orders || [];

  const scrollToTop = () => {
    scrollRef.current.scrollIntoView();
  };

  const OnProductToggleSelect = () => {
    setProductDropdown((prevState) => !prevState);
  };

  const OnPlyToggleSelect = () => {
    setPlyDropdown((prevState) => !prevState);
  };

  const OnCurrencyToggleSelect = () => {
    setCurrencyDropdown((prevState) => !prevState);
  };

  const OnCountryToggleSelect = () => {
    setCountryDropdown((prevState) => !prevState);
  };

  const OnStateToggleSelect = () => {
    setStateDropdown((prevState) => !prevState);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const handleClose = () => {
    scrollToTop();
    setProductData();
    setGrain("");
    setWidth("");
    setLength("");
    setWeight("");
    setQuantity("");
    setCoreod("");
    setNetPrice("");
    setDefaultLowerOrderTol("");
    setDefaultUpperOrderTol("");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setPlanningWeightValue("");
    setPlanningQuantityValue("");
    setCoreValues();
    setReelvalues();
    setDealerPriceValue();
    setPlannedReels(0);
    setMeasurementData();
    setCheckedBox(true);
    setMixedGrain(false);
    setGrainChanges(true);
    setRerender(false);
    setPlanningWtErr(false);
    setReelODValidationError(false);
    setCoreOdValidationError(false);
    setMixedGrainEnabled(false);
    setToleranceDisabled(false);
    form.resetFields();
    props.onCloseGrade();
  };

  const onChangeCollpase = (key) => {};

  const handleType = async (e) => {
    setSelectedType(e);
    if (e === "sheet") {
      setSelectedPly(1);
    }
    setProducts([]);

    form.setFieldsValue({
      length: "",
      width: "",
      reel_OD: "",
      core_OD: "",
      weight: "",
      quantity: "",
      planning_quantity: "",
      planning_weight: "",
      no_of_reel_sheet: "",
      planned_weight: "",
      dealer_price: "",
      customer_price: "",
      packaging_name: "",
      remarks: "",
      ply: "",
    });

    form.resetFields([
      "width",
      "length",
      "packaging_name",
      "product_code",
      "ply",
    ]);
    setLength("");
    setWidth("");
    setWeight("");
    setReelod("");
    setCoreod("");
    setQuantity("");
    setPlanningQuantityValue("");
    setPlanningWeightValue("");
    setSelectedPackaging("");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setProductData();
    setDealerPriceValue();
    setPlannedReels(0);
    setPlannedWeight(0);
    setPlanningWtErr(false);
    setReelODValidationError(false);

    form.setFieldsValue({
      dimensionUnit: measurementData.data.units_management.length.default,
    });
    form.setFieldsValue({
      weightUnit: measurementData.data.units_management.weight.default,
    });
    form.setFieldsValue({
      planning_weightUnit: measurementData.data.units_management.weight.default,
    });

    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    setOrderQuantity("weight");
    setSelectedReelOD([]);
    setOrderQuantityTabArray([
      { label: "Weight", value: "weight" },
      {
        label: `${capitalize(e)}s`,
        value: e,
      },
    ]);
    if (e === "reel") {
      setCoreod(
        reelCoreData?.default_core_id
          ? reelCoreData?.default_core_id +
              " " +
              reelCoreData?.default_core_unit
          : ""
      );
      setReelod(
        reelCoreData?.default_reel_od
          ? reelCoreData?.default_reel_od +
              " " +
              reelCoreData?.default_reel_unit
          : ""
      );
      form.setFieldsValue({
        reel_OD: reelCoreData?.default_reel_od
          ? reelCoreData?.default_reel_od +
            " " +
            reelCoreData?.default_reel_unit
          : "",
      });
      form.setFieldsValue({
        core_OD: reelCoreData?.default_core_id
          ? reelCoreData?.default_core_id +
            " " +
            reelCoreData?.default_core_unit
          : "",
      });
      reelCoreData?.default_reel_od
        ? setSelectedReelOD([
            {
              value:
                reelCoreData?.default_reel_od +
                " " +
                reelCoreData?.default_reel_unit,
            },
          ])
        : setSelectedReelOD([]);
    }

    try {
      const resp = await getMachineGradeSelectForConfig();
      if (!resp.error) {
        setGrain(
          resp?.data?.data?.settings.order_types[1]?.grain === "long"
            ? "Long Grain"
            : "Short Grain"
        );
        form.setFieldsValue({
          grain:
            resp?.data?.data?.settings.order_types[1]?.grain === "long"
              ? "Long Grain"
              : "Short Grain",
        });

        if (orderQuantity == "weight") {
          form.setFieldsValue({
            upper_tolerance:
              resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
                ?.upper_tolerance,
          });
          form.setFieldsValue({
            lower_tolerance:
              resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
                ?.lower_tolerance,
          });
          setDefaultUpperOrderTol(
            resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
              ?.upper_tolerance
          );
          setDefaultLowerOrderTol(
            resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
              ?.lower_tolerance
          );
          setToleranceDisabled(
            resp?.data?.data?.settings?.order_types[2]?.value
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlePlyChange = (e) => {
    console.log(e);
    setProducts([]);
    setSelectedPly(e);
    setProductData();
    form.resetFields(["product_code"]);
  };

  const handleProduct = (e) => {
    getProductDetails(e)
      .then((response) => {
        let currencyData = currency_List?.filter(
          (item) => response?.data.units.price === item.code
        );
        response.data["symbol"] = currencyData[0]?.symbol;
        setProductData(response.data);
      })
      .catch((error) => {
        console.log("Error in getting product specification list");
      });
  };

  const onLengthChange = async (e) => {
    setLength(e.target.value);
  };

  const onWidthChange = async (e) => {
    setWidth(e.target.value);
  };

  const onChangeWidthUnit = (e) => {
    setWidthUnit(e);
  };

  const onLowerTolChange = (e, type) => {
    if (type === "order_tolerance") {
      setDefaultLowerOrderTol(e.target.value);
      form.setFieldsValue({ order_lower_tolerance: e.target.value });
      calculateOrderTol(weightValue, e.target.value, "orderLoweTol");
    }
  };

  const onUpperTolChange = (e, type) => {
    if (type === "order_tolerance") {
      setDefaultUpperOrderTol(e.target.value);
      form.setFieldsValue({ order_upper_tolerance: e.target.value });
      calculateOrderTol(weightValue, e.target.value, "orderUpperTol");
    }
  };

  const onGrainChange = async (e) => {
    setGrain(e);
  };

  const mixedGrainHandler = (e) => {
    setMixedGrain(e.target.checked);
  };

  const grainChangesHandler = (e) => {
    setGrainChanges(e.target.checked);
  };

  const handleQuantityChange = (e) => {
    setOrderQuantity(e.target.value);
    form.setFieldsValue({ weight: "" });
    form.setFieldsValue({ quantity: "" });
    form.setFieldsValue({ planning_quantity: "" });
    form.setFieldsValue({ no_of_reel_sheet: "" });
    form.setFieldsValue({ planning_weight: "" });
    form.setFieldsValue({ dealer_price: "" });
    form.setFieldsValue({ customer_price: "" });
    form.setFieldsValue({ packaging_name: "" });
    form.setFieldsValue({ remarks: "" });
    form.setFieldsValue({
      minimum_reel_od: "",
      max_reel_od: "",
      planned_weight: "",
    });
    setWeight("");
    setQuantity("");
    setPlanningQuantityValue("");
    setPlanningWeightValue("");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setDealerPriceValue();
    setPlannedReels(0);
    setPlannedWeight(0);
    setPlanningWtErr(false);
    setReelODValidationError(false);
    setCoreOdValidationError(false);
    form.setFieldsValue({
      weightUnit: measurementData.data.units_management.weight.default,
    });
    form.setFieldsValue({
      planning_weightUnit: measurementData.data.units_management.weight.default,
    });
    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    if (e.target.value == "reel") {
      if (reelCoreData) {
        setCoreod(
          reelCoreData.default_core_id
            ? reelCoreData.default_core_id +
                " " +
                reelCoreData.default_core_unit
            : ""
        );
        setReelod(
          reelCoreData.default_reel_od
            ? reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit
            : ""
        );
        form.setFieldsValue({
          reel_OD: reelCoreData.default_reel_od
            ? reelCoreData.default_reel_od +
              " " +
              reelCoreData.default_reel_unit
            : "",
        });
        form.setFieldsValue({
          core_OD: reelCoreData.default_core_id
            ? reelCoreData.default_core_id +
              " " +
              reelCoreData.default_core_unit
            : "",
        });
        reelCoreData.default_reel_od
          ? setSelectedReelOD([
              {
                value:
                  reelCoreData.default_reel_od +
                  " " +
                  reelCoreData.default_reel_unit,
              },
            ])
          : setSelectedReelOD([]);
      }
    }
  };

  const handleWeight = (e) => {
    setWeight(parseFloat(e.target.value));
    setPlanningWeightValue(parseFloat(e.target.value));
    form.setFieldsValue({ weight: e.target.value });
    form.setFieldsValue({ planning_weight: e.target.value });
    calculateOrderTol(
      e.target.value,
      form.getFieldValue("order_upper_tolerance"),
      "orderUpperTol"
    );
    calculateOrderTol(
      e.target.value,
      form.getFieldValue("order_lower_tolerance"),
      "orderLowerTol"
    );
    if (
      parseFloat(form.getFieldValue("planning_weight")) &&
      parseFloat(e.target.value) <
        parseFloat(form.getFieldValue("planning_weight"))
    ) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
    }
  };

  const onChangeWeightUnit = (e) => {
    setUnitPlaceholder(e);
    form.setFieldsValue({ planning_weightUnit: e });
  };

  const onQuantityValueChange = (e) => {
    setQuantity(e.target.value);
    setPlanningQuantityValue(e.target.value);
    form.setFieldsValue({ quantity: e.target.value });
    form.setFieldsValue({ planning_quantity: e.target.value });
    if (
      parseFloat(form.getFieldValue("planning_quantity")) &&
      parseFloat(e.target.value) <
        parseFloat(form.getFieldValue("planning_quantity"))
    ) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
    }
  };

  const calculateOrderTol = (weight, tolValue, type) => {
    if (type == "orderUpperTol") {
      if (weight && tolValue) {
        let upperTol = (weight * (100 + parseFloat(tolValue))) / 100;
        setOrderUpperTol(parseFloat(upperTol).toFixed(3));
      } else {
        setOrderUpperTol(0.0);
      }
    } else {
      if (weight && tolValue) {
        let lowerTol = (weight * (100 - parseFloat(tolValue))) / 100;
        setOrderLowerTol(parseFloat(lowerTol).toFixed(3));
      } else {
        setOrderLowerTol(0.0);
      }
    }
  };

  const handlePackaging = (e) => {
    setSelectedPackaging(e);
  };

  const handlePlanningWeight = (e) => {
    setPlanningWeightValue(parseFloat(e.target.value));
    if (
      parseFloat(weightValue) &&
      parseFloat(e.target.value) > parseFloat(weightValue)
    ) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
      form.setFieldsValue({ planning_weight: e.target.value });
    }
  };

  const onPlanningQuantityValueChange = (e) => {
    setPlanningQuantityValue(e.target.value);
    if (
      parseFloat(quantityValue) &&
      parseFloat(e.target.value) > parseFloat(quantityValue)
    ) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
      form.setFieldsValue({ planning_quantity: e.target.value });
    }
  };

  const handleRewinderType = (e) => {
    setCoreOdValidationError(false);
    setOuterDiameter(e.target.value);
    setPlannedReels(0);
    form.setFieldsValue({ no_of_reel_sheet: 0 });
    form.setFieldsValue({ planned_weight: 0 });
    form.setFieldsValue({
      reelOD_unit: measurementData.data.units_management.length.default,
    });
    setPlannedWeight(0);
  };

  const handleCoreOD = (e) => {
    setCoreod(e);
    if (orderQuantity == "reel" && selectedType == "reel") {
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let reelodConversion =
        orderDim_Rewinder_Unit_Conversion[reelOD?.split(" ")[1]];
      let coreODValue = e?.split(" ")[0] * coreodConversion;
      let reelOdValue = reelOD?.split(" ")[0] * reelodConversion;
      if (parseFloat(coreODValue) > (reelOD && parseFloat(reelOdValue))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if (outerDiameter == "constant") {
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let coreODValue = e?.split(" ")[0] * coreodConversion;
      if (selectedReelOD?.length == 1) {
        let reelodConversion =
          orderDim_Rewinder_Unit_Conversion[
            selectedReelOD[0]?.value?.split(" ")[1]
          ];
        let reelOdValue =
          selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion;
        if (parseFloat(coreODValue) > parseFloat(reelOdValue)) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      } else if (selectedReelOD?.length > 1) {
        let dataArr = [];
        for (let ind = 0; ind < selectedReelOD.length; ind++) {
          let convertedValue =
            selectedReelOD[ind]?.value?.split(" ")[0] *
            orderDim_Rewinder_Unit_Conversion[
              selectedReelOD[ind]?.value?.split(" ")[1]
            ];
          dataArr.push(convertedValue);
        }
        let minValue = Math.min(...dataArr);
        if (
          (coreODValue && parseFloat(coreODValue)) >
          (minValue && parseFloat(minValue))
        ) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      } else {
        setCoreOdValidationError(false);
      }
    } else if (outerDiameter == "range") {
      let rangeUnit = form.getFieldValue("reelOD_unit");
      let minReel = form.getFieldValue("min_reel_od");
      let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
      let reelODValue = minReel * minReelConversion;
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let coreODValue = e?.split(" ")[0] * coreodConversion;

      if (
        (reelODValue && parseFloat(reelODValue)) <
        (e && parseFloat(coreODValue))
      ) {
        setRangeValidationError(true);
      } else {
        setRangeValidationError(false);
      }
    }
  };

  const handleReelOD = (e) => {
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let reelodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
    let reelOdValue = e?.split(" ")[0] * reelodConversion;
    setReelod(e);
    if (parseFloat(reelOdValue) < (coreOD && parseFloat(coreODValue))) {
      setCoreOdValidationError(true);
    } else {
      setCoreOdValidationError(false);
    }
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
    if (data.length == 1) {
      let reelodConversion =
        orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
      let reelOdValue = data[0]?.value?.split(" ")[0] * reelodConversion;
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(reelOdValue)) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if (data.length > 1) {
      let dataArr = [];
      for (let ind = 0; ind < data.length; ind++) {
        let convertedValue =
          data[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[data[ind]?.value?.split(" ")[1]];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);
      if (
        (coreODValue && parseFloat(coreODValue)) >
        (minValue && parseFloat(minValue))
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    }
  };

  const removeReelOD = (data) => {
    let array = selectedReelOD;
    let newArray = array.filter((item) => {
      return !(item.value === data.value);
    });
    setSelectedReelOD(newArray);
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
    if (newArray && newArray?.length == 1) {
      let reelodConversion =
        orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
      let reelOD = newArray[0]?.value?.split(" ")[0] * reelodConversion;

      if (
        (coreODValue && parseFloat(coreODValue)) >
        (reelOD && parseFloat(reelOD))
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if (newArray && newArray.length > 1) {
      let dataArr = [];
      for (let ind = 0; ind < newArray.length; ind++) {
        let convertedValue =
          newArray[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[
            newArray[ind]?.value?.split(" ")[1]
          ];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if (
        (coreODValue && parseFloat(coreODValue)) >
        (minValue && parseFloat(minValue))
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    }
  };

  const onMinReelODChange = (e) => {
    let rangeUnit = form.getFieldValue("reelOD_unit");
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
    let reelOD = e.target.value * minReelConversion;
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;

    if (
      (reelOD && parseFloat(reelOD)) < (coreODValue && parseFloat(coreODValue))
    ) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }

    if (
      parseFloat(e.target.value) > parseFloat(form.getFieldValue("max_reel_od"))
    ) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const onMaxReelODChange = (e) => {
    setRangeValidationError(false);
    if (
      parseFloat(e.target.value) < parseFloat(form.getFieldValue("min_reel_od"))
    ) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const onRangeUnitChange = (e) => {
    let minReel = form.getFieldValue("min_reel_od");
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[e];
    let reelODValue = minReel * minReelConversion;
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;

    if (
      (reelODValue && parseFloat(reelODValue)) <
      (coreODValue && parseFloat(coreODValue))
    ) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }
  };

  const rewinderReelsCal = () => {
    setPlannedReels(0);
    let size;
    if (selectedType === "reel") {
      size = widthValue;
    } else {
      size =
        grainValue === "Long Grain" ||
        grainValue === "long" ||
        grainValue === "long grain"
          ? parseFloat(widthValue) > parseFloat(lengthValue)
            ? lengthValue
            : widthValue
          : parseFloat(lengthValue) > parseFloat(widthValue)
          ? lengthValue
          : widthValue;
    }
    if (
      selectedType === "reel" &&
      orderQuantity === "reel" &&
      planningQuantityValue
    ) {
      form.setFieldsValue({ no_of_reel_sheet: planningQuantityValue });
      setRerender(true);
      setPlannedReels(planningQuantityValue);
    } else {
      if (planningWeightValue || planningQuantityValue) {
        if (
          size &&
          coreOD &&
          ((selectedReelOD && selectedReelOD?.length == 1) ||
            (reelOD && orderQuantity === "reel")) &&
          productData.bulk &&
          size !== 0 &&
          (parseFloat(coreOD.split(" ")[0]) !==
            parseFloat(selectedReelOD[0]?.value.split(" ")[0]) ||
            parseFloat(coreOD.split(" ")[0]) !==
              parseFloat(reelOD.split(" ")[0]))
        ) {
          let reelDiaUnit;
          let reelODValue;
          if (selectedType === "reel" && orderQuantity === "reel") {
            reelDiaUnit = reelOD?.split(" ")[1];
            reelODValue = reelOD?.split(" ")[0];
          } else {
            reelDiaUnit = selectedReelOD[0]?.value.split(" ")[1];
            reelODValue = selectedReelOD[0]?.value.split(" ")[0];
          }
          let reelConversionValue =
            orderDim_Rewinder_Unit_Conversion[reelDiaUnit];

          let coreDiaUnit = coreOD.split(" ")[1];
          let coreConversionValue =
            orderDim_Rewinder_Unit_Conversion[coreDiaUnit];

          let dimensionUnit = form.getFieldValue("dimensionUnit");
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let weightUnit = form.getFieldValue("weightUnit");
          let weightConversionValue = weight_Unit_Conversions[weightUnit];

          calculatePlannedReels(
            size * conversionValue,
            lengthValue * conversionValue,
            widthValue * conversionValue,
            planningWeightValue * weightConversionValue,
            productData.bulk,
            productData.gsm,
            coreOD.split(" ")[0] * coreConversionValue,
            reelODValue * reelConversionValue
          );
        } else {
          setPlannedReels(0);
          form.setFieldsValue({ no_of_reel_sheet: 0 });
          setRerender(true);
        }
      } else {
        setPlannedReels(0);
        form.setFieldsValue({ no_of_reel_sheet: 0 });
        setRerender(true);
      }
    }
  };

  const calculatePlannedReels = (
    size,
    length,
    width,
    weight,
    bulk,
    gsm,
    coreOd,
    reelOd
  ) => {
    setPlannedReels(0);
    const value =
      orderQuantity === "weight"
        ? ((weight ? parseFloat(weight) : 0) *
            1000 *
            1000 *
            parseFloat(bulk) *
            4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)))
        : (parseFloat(length) *
            parseFloat(width) *
            parseFloat(planningQuantityValue) *
            parseFloat(gsm) *
            parseFloat(bulk) *
            4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) -
              Math.pow(parseFloat(coreOd), 2)) *
            10000);
    form.setFieldsValue({
      no_of_reel_sheet: Math.round(value.toFixed(3))
        ? Math.round((value * 1).toFixed(3))
        : 1,
    });
    setRerender(true);
    setPlannedReels((value * 1).toFixed(3));
  };

  const onPlannedReelsChange = (e) => {
    form.setFieldsValue({ no_of_reel_sheet: e.target.value });
    setRerender(true);
  };

  const plannedWeightCal = () => {
    setPlannedWeight(0);
    let reels = form.getFieldValue("no_of_reel_sheet");
    let size;
    if (selectedType === "reel") {
      size = widthValue;
    } else {
      size =
        grainValue === "Long Grain" ||
        grainValue === "long" ||
        grainValue === "long grain"
          ? parseFloat(widthValue) > parseFloat(lengthValue)
            ? lengthValue
            : widthValue
          : parseFloat(lengthValue) > parseFloat(widthValue)
          ? lengthValue
          : widthValue;
    }

    if (
      size &&
      coreOD &&
      (selectedReelOD || (reelOD && orderQuantity === "reel"))
    ) {
      let reelDiaUnit;
      let reelODValue;
      if (selectedType === "reel" && orderQuantity === "reel") {
        reelDiaUnit = reelOD?.split(" ")[1];
        reelODValue = reelOD?.split(" ")[0];
      } else {
        reelDiaUnit = selectedReelOD[0]?.value.split(" ")[1];
        reelODValue = selectedReelOD[0]?.value.split(" ")[0];
      }
      let reelConversionValue = orderDim_Rewinder_Unit_Conversion[reelDiaUnit];

      let coreDiaUnit = coreOD.split(" ")[1];
      let coreConversionValue = orderDim_Rewinder_Unit_Conversion[coreDiaUnit];

      let dimensionUnit = form.getFieldValue("dimensionUnit");
      let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

      calculatePlannedWeight(
        size * conversionValue,
        productData?.bulk,
        reelODValue * reelConversionValue,
        coreOD.split(" ")[0] * coreConversionValue,
        reels
      );
    } else {
      if (selectedType === "reel") {
        form.setFieldsValue({ planned_weight: 0 });
      } else {
        if (selectedType === "sheet" && orderQuantity === "weight") {
          if (planningWeightValue) {
            setPlannedWeight(parseFloat(planningWeightValue).toFixed(2));
            form.setFieldsValue({
              planned_weight: parseFloat(planningWeightValue).toFixed(2),
            });
          } else {
            form.setFieldsValue({ planned_weight: 0 });
          }
        } else {
          let weightUnit = form.getFieldValue("weightUnit");

          let dimensionUnit = form.getFieldValue("dimensionUnit");
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = lengthValue * conversionValue;
          let width_Value = widthValue * conversionValue;

          const value =
            (length_Value *
              width_Value *
              planningQuantityValue *
              productData?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[unitPlaceholder];
          setPlannedWeight(
            plannedWeightValue ? plannedWeightValue.toFixed(3) : 0
          );
          form.setFieldsValue({
            planned_weight: plannedWeightValue
              ? plannedWeightValue.toFixed(3)
              : 0,
          });
        }
      }
    }
  };

  const calculatePlannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    let weightUnitValue = form.getFieldValue("weightUnit");
    let plannedWeightValue =
      value * conversionFactorTonneToUnits[weightUnitValue];
    setPlannedWeight(plannedWeightValue ? plannedWeightValue.toFixed(3) : 0);
    form.setFieldsValue({
      planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0,
    });
  };

  const soDocumentsUpload = async (soNumber) => {
    for (let i = 0; i < props.uploadDocument.length; i++) {
      try {
        // Step 1: Generate signed URL for upload
             const res = await getImageURL({
               bucket_key: `${soNumber}/${props.uploadDocument[i].name}}`,
               operation: "upload"
             });
             // Step 2: Upload file to that signed URL
             const uploadResponse = await newUploadOrders(res, props.uploadDocument[i]);
      } catch (err) {
        console.log(err);
      }
    }
  };
  const addSoDetails = async () => {
    const body = {
      date: props?.poDetails?.date,
      other_documents_location: props?.poDetails?.uploadedDocsArr,
      reference_number: props?.poDetails?.refNumber,
      dummy:true
    };
    console.log(body);
    await addSo(body)
      .then((response) => {
        console.log("so details", response);
        props.setSoNumber(response.data.number);
        soNo = response.data.number;
        soDocumentsUpload(soNo);
        props.toasterAction({
          error: response.error,
          msg: `The SO ${response.data.number} is successfully saved <br>and the Order is added successfuly`,
        });
      })
      .catch((error) => {
        console.log("Error in adding new po:", error);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
      });
  };
  const addOrder = async (event, withPo) => {
    let reelODArr = [];
    let reelod = [];
    selectedReelOD?.map((item) => {
      reelODArr.push(item.value);
    });
    let quantityKey = 0;
    let plannedSheetsValue = 0;
    if (
      ((selectedReelOD && selectedReelOD?.length == 1) ||
        (orderQuantity == "reel" && selectedType == "reel")) &&
      outerDiameter == "constant"
    ) {
      quantityKey = parseFloat(event?.no_of_reel_sheet);
    }
    if (orderQuantity == "sheet" && selectedType == "sheet") {
      plannedSheetsValue = parseFloat(planningQuantityValue);
    }

    let plannedWeightValue = 0;
    if (
      ((((event.core_OD && selectedReelOD && selectedReelOD?.length == 1) ||
        (!event.core_OD && selectedReelOD && selectedReelOD?.length == 0) ||
        (!event.core_OD && selectedReelOD && selectedReelOD?.length == 1) ||
        (event.core_OD && selectedReelOD && selectedReelOD?.length == 0)) &&
        event.type?.toLowerCase() == "sheet") ||
        (((event.core_OD &&
          ((selectedReelOD && selectedReelOD?.length == 1) ||
            (event.reel_OD && orderQuantity == "reel"))) ||
          (!event.core_OD &&
            ((selectedReelOD && selectedReelOD?.length == 0) ||
              (!event.reel_OD && orderQuantity == "reel")) &&
            orderQuantity != "weight") ||
          (event.core_OD &&
            ((selectedReelOD && selectedReelOD?.length == 0) ||
              (!event.reel_OD && orderQuantity == "reel")) &&
            orderQuantity != "weight")) &&
          event.type?.toLowerCase() == "reel")) &&
      outerDiameter == "constant"
    ) {
      plannedWeightValue = parseFloat(event?.planned_weight);
    } else if (
      (((selectedReelOD && selectedReelOD?.length > 1) || event.core_OD) &&
        orderQuantity == "weight" &&
        outerDiameter == "constant") ||
      (orderQuantity == "weight" && outerDiameter == "range")
    ) {
      plannedWeightValue = parseFloat(event?.planning_weight);
    } else if (
      (outerDiameter == "range" && orderQuantity != "weight") ||
      (selectedReelOD &&
        selectedReelOD?.length > 1 &&
        orderQuantity == "sheet" &&
        outerDiameter == "constant")
    ) {
      plannedWeightValue = 0;
    }

    const body = {
      type: event.type?.toLowerCase(),
      length: event.length ? parseFloat(event.length) : 0,
      width: event.width ? parseFloat(event.width) : 0,
      ...(event.grain && { grain: event.grain?.split(" ")[0].toLowerCase() }),
      delivery_address_line_1: event.delivery_address_line_1,
      delivery_address_line_2: event.delivery_address_line_2,
      delivery_city: event.delivery_city,
      delivery_state: event.delivery_state,
      delivery_country: Country.getCountryByCode(event.delivery_country)
        ? Country.getCountryByCode(event.delivery_country).name
        : event.delivery_country,
      delivery_pincode: event.delivery_pincode,
      net_price: netPrice ? parseFloat(netPrice) : 0,
      dealer_price: event.dealer_price ? parseFloat(event.dealer_price) : 0,
      customer_price: event.customer_price
        ? parseFloat(event.customer_price)
        : 0,
      currency: event.currency,
      delivery_date: props.isSo ? null : event.delivery_date,
      ...(props.isSo
        ? { so: soNo ? soNo : props.soNumber }
        : {
            po: !props.isOrders
              ? toHandlePOName(props?.poDetails?.poNumber.toUpperCase())+"#%#"+props?.poDetails?.customer
              : toHandlePOName(props?.poDetails?.poNumber)+"#%#"+props?.poDetails?.customer,
          }),
      customer: props?.poDetails?.customer,
      product: event.product_code,
      remarks: event.remarks,
      comments: [],
      quantity_type: orderQuantity === "weight" ? "weight" : "reel_sheet",
      ...(orderQuantity !== "weight" && {
        no_of_reel_sheet: quantityValue ? parseFloat(quantityValue) : 0,
      }),
      ...(orderQuantity === "weight" && { weight: parseFloat(weightValue) }),
      use_po_address: checkedBox ? true : false,
      ...(event.packaging_name && {
        packaging_details: event.packaging_name
          ? parseFloat(event.packaging_name)
          : "",
      }),
      // planned_weight: (((selectedReelOD && selectedReelOD?.length == 1) || (event.type.toLowerCase() == "sheet") || (orderQuantity == "weight" && event.type.toLowerCase() == "reel")
      // || (event.core_OD && event.reel_OD && event.type.toLowerCase() == "reel" && orderQuantity == "reel")) && outerDiameter == "constant") ?
      // parseFloat(event?.planned_weight) : (orderQuantity === "weight" ?  parseFloat(event?.planning_weight) : 0),
      planned_weight: plannedWeightValue,
      quantity: quantityKey,
      planned_sheets: plannedSheetsValue,
      planning_weight: event.planning_weight
        ? parseFloat(event.planning_weight)
        : 0,
      planning_quantity: event.planning_quantity
        ? parseFloat(event.planning_quantity)
        : 0,
      id_od_type: outerDiameter,
      inner_dia: event.core_OD ? event.core_OD : "",
      ...(outerDiameter == "constant" && {
        outer_dia:
          selectedType == "reel" && orderQuantity === "reel"
            ? event.reel_OD === ""
              ? reelod
              : [event.reel_OD]
            : reelODArr,
      }),
      ...(selectedType === "sheet" && {
        rotation: grainChanges,
        grain_mixing: mixedGrain,
      }),
      ...(selectedType === "reel" && {
        ply: parseFloat(selectedPly),
      }),
      tolerances: {
        ...(orderQuantity === "weight" && {
          weight: {
            upper_tolerance: parseFloat(event?.order_upper_tolerance),
            lower_tolerance: parseFloat(event?.order_lower_tolerance),
            calculated_upper_tolerance: parseFloat(orderUpperTol),
            calculated_lower_tolerance: parseFloat(orderLowerTol),
            units: unitPlaceholder,
          },
        }),
      },
      ...(outerDiameter == "range" && {
        minimum_reel_od: event.min_reel_od ? parseFloat(event.min_reel_od) : 0,
      }),
      ...(outerDiameter == "range" && {
        maximum_reel_od: event.max_reel_od ? parseFloat(event.max_reel_od) : 0,
      }),
      units: {
        ...(orderQuantity === "weight" && { weight: event.weightUnit }),
        length: event.dimensionUnit,
        width: event.dimensionUnit,
        planned_weight: unitPlaceholder,
        dealer_price: event.currency,
        net_price: event.currency,
        customer_price: event.currency,
        per_weight_unit: productData.units.per_weight_unit,
        ...(outerDiameter == "range" && { minimum_reel_od: event.reelOD_unit }),
        ...(outerDiameter == "range" && { maximum_reel_od: event.reelOD_unit }),
      },
      category: "so"
    };
    console.log({ body: body });

    postOrder(body)
      .then((response) => {
        props.rendering(true);
        !add
          ? setTimeout(() => {
              props.toasterAction({
                error: response.error,
                msg: "The order is successfully added",
              });
              form.resetFields();
              setGrain("");
              setWidth("");
              setLength("");
              setWeight("");
              setQuantity("");
              setCoreod("");
              setNetPrice("");
              setDefaultLowerOrderTol("");
              setDefaultUpperOrderTol("");
              setOrderUpperTol("");
              setOrderLowerTol("");
              setPlanningWeightValue("");
              setPlanningQuantityValue("");
              setDealerPriceValue();
              setPlannedReels(0);
              setToleranceDisabled(false);
              setMixedGrain(false);
              setGrainChanges(true);
              setPlanningWtErr(false);
              setReelODValidationError(false);
              setCoreOdValidationError(false);
              setMixedGrainEnabled(false);
              setOrderQuantityTabArray([
                { label: "Weight", value: "weight" },
                {
                  label:
                    orderTypes.length > 0
                      ? `${capitalize(orderTypes[0].value)}s`
                      : "",
                  value: orderTypes.length > 0 ? orderTypes[0].value : "",
                },
              ]);
              setUnitPlaceholder(
                measurementData.data.units_management.weight.default
              );
              form.setFieldsValue({
                weightUnit:
                  measurementData.data.units_management.weight.default,
              });
              form.setFieldsValue({
                planning_weightUnit:
                  measurementData.data.units_management.weight.default,
              });
              form.setFieldsValue({
                dimensionUnit:
                  measurementData.data.units_management.length.default,
              });
              form.setFieldsValue({
                currency:
                  measurementData.data.units_management.currency.default,
              });
              if (props?.page && props?.page == "poPage") {
                // setActionToaster({
                //   error: false,
                //   msg: "The order is successfully added",
                // });
                // showToaster();
                history("../order-records", {
                  state: {
                    poBackKey: true,
                  },
                });
              } else {
                props.showToaster();
              }
            }, 0)
          : setTimeout(() => {
              setActionToaster({
                error: false,
                msg: "The order is successfully added",
              });
              showToaster();
              form.resetFields();
              setGrain("");
              setWidth("");
              setLength("");
              setWeight("");
              setQuantity("");
              setCoreod("");
              setNetPrice("");
              setDefaultLowerOrderTol("");
              setDefaultUpperOrderTol("");
              setOrderUpperTol("");
              setOrderLowerTol("");
              setPlanningWeightValue("");
              setPlanningQuantityValue("");
              setDealerPriceValue();
              setPlannedReels(0);
              setToleranceDisabled(false);
              setMixedGrain(false);
              setGrainChanges(true);
              setPlanningWtErr(false);
              setReelODValidationError(false);
              setCoreOdValidationError(false);
              setMixedGrainEnabled(false);
              setOrderQuantityTabArray([
                { label: "Weight", value: "weight" },
                {
                  label:
                    orderTypes.length > 0
                      ? `${capitalize(orderTypes[0].value)}s`
                      : "",
                  value: orderTypes.length > 0 ? orderTypes[0].value : "",
                },
              ]);
              setUnitPlaceholder(
                measurementData.data.units_management.weight.default
              );
              form.setFieldsValue({
                weightUnit:
                  measurementData.data.units_management.weight.default,
              });
              form.setFieldsValue({
                planning_weightUnit:
                  measurementData.data.units_management.weight.default,
              });
              form.setFieldsValue({
                dimensionUnit:
                  measurementData.data.units_management.length.default,
              });
              form.setFieldsValue({
                currency:
                  measurementData.data.units_management.currency.default,
              });
              showToaster();
              props.showToaster();
            }, 0);
      })
      .catch((error) => {
        console.log("Error in adding new order:", error);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
        props.onClose();
      });
  };

  const onFinish = (e) => {
    e = {
      ...e,
      delivery_date:
        new Date(e.delivery_date).getFullYear() +
        "-" +
        (new Date(e.delivery_date).getMonth() + 1) +
        "-" +
        new Date(e.delivery_date).getDate() +
        "T00:00:00Z",
      delivery_address_line_1: form.getFieldValue("delivery_address_line_1"),
      delivery_address_line_2: form.getFieldValue("delivery_address_line_2"),
      delivery_city: form.getFieldValue("delivery_city"),
      delivery_state: form.getFieldValue("delivery_state"),
      delivery_country: form.getFieldValue("delivery_country"),
      delivery_pincode: form.getFieldValue("zip_code"),
      order_upper_tolerance: form.getFieldValue("order_upper_tolerance"),
      order_lower_tolerance: form.getFieldValue("order_lower_tolerance"),
      planned_weight: form.getFieldValue("planned_weight"),
      no_of_reel_sheet: form.getFieldValue("no_of_reel_sheet"),
      planning_weight: form.getFieldValue("planning_weight"),
      planning_quantity: form.getFieldValue("planning_quantity"),
      core_OD: form.getFieldValue("core_OD"),
      reel_OD: form.getFieldValue("reel_OD"),
      minimum_reel_od: form.getFieldValue("minimum_reel_od"),
      maximum_reel_od: form.getFieldValue("maximum_reel_od"),
    };
    if (!coreOdValidationError && !reelODValidationError && !planningWtErr) {
      scrollToTop();
      !props.isOrders
        ? addSoDetails()
            .then(() => {
              addOrder(e, true);
            })
            .catch(() => {
              console.log("Error");
            })
        : addOrder(e, false);

      form.setFieldsValue({
        length: "",
        width: "",
        weight: "",
        quantity: "",
        planning_quantity: "",
        planning_weight: "",
        no_of_reel_sheet: "",
        planned_weight: "",
        dealer_price: "",
        customer_price: "",
        packaging_name: "",
        remarks: "",
      });

      form.resetFields(["width", "length", "packaging_name", "product_code"]);
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setPlanningWtErr(false);
      setReelODValidationError(false);
      !add && props.onClose();
      form.setFieldsValue({
        dimensionUnit: measurementData.data.units_management.length.default,
      });
      form.setFieldsValue({
        weightUnit: measurementData.data.units_management.weight.default,
      });
      form.setFieldsValue({
        planning_weightUnit:
          measurementData.data.units_management.weight.default,
      });

      setUnitPlaceholder(measurementData.data.units_management.weight.default);
      setOrderQuantity("weight");
      setOrderQuantityTabArray([
        { label: "Weight", value: "weight" },
        {
          label:
            orderTypes.length > 0 ? `${capitalize(orderTypes[0].value)}s` : "",
          value: orderTypes.length > 0 ? orderTypes[0].value : "",
        },
      ]);
    }
  };

  const onFinishFailed = () => {
    scrollToTop();
  };  

  useEffect(() => {
    (async () => {
      form.setFieldsValue({
        delivery_address_line_1: props?.poDetails?.delivery_address_line_1,
        delivery_address_line_2: props?.poDetails?.delivery_address_line_2,
        delivery_state: props?.poDetails?.state,
        delivery_city: props?.poDetails?.City,
        zip_code: props?.poDetails?.pincode,
        delivery_country: props?.poDetails?.country,
      });

      getMachineGradeSelect()
        .then((response) => {
          const reelValue = response.data.data.settings.order_types[0].value;
          const sheetValue = response.data.data.settings.order_types[1].value;
          const typeData =
            reelValue && sheetValue
              ? [
                  { label: "Reel", value: "reel" },
                  { label: "Sheet", value: "sheet" },
                ]
              : reelValue
              ? [{ label: "Reel", value: "reel" }]
              : sheetValue
              ? [{ label: "Sheet", value: "sheet" }]
              : [];
          setOrderTypes(typeData);
          setSelectedType(typeData[0].value);

          setOrderQuantityTabArray([
            { label: "Weight", value: "weight" },
            {
              label: `${capitalize(typeData[0].value)}s`,
              value: typeData[0].value,
            },
          ]);
          setOrderQuantity("weight");
        })
        .catch((error) => console.log(error));
      let measurement_data;
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          measurement_data = unitData;
          setMeasurementData(unitData);

          form.setFieldsValue({
            dimensionUnit: unitData.data.units_management.length.default,
          });
          form.setFieldsValue({
            reelOD_unit: unitData.data.units_management.length.default,
          });
          setDimesionUnitList(unitData.data.units_management.length.data);

          form.setFieldsValue({
            weightUnit: unitData.data.units_management.weight.default,
          });
          setWeightUnitList(unitData.data.units_management.weight.data);

          form.setFieldsValue({
            currency: unitData.data.units_management.currency.default,
          });
          let currencyData = currency_List?.filter((item) =>
            unitData.data.units_management.currency.data.includes(item.code)
          );
          setCurrencyUnitData(currencyData);
          let netPriceSymbol = currency_List?.filter(
            (item) =>
              unitData.data.units_management.currency.default == item.code
          );
          setNetPriceSymbol(netPriceSymbol[0]?.symbol);

          setUnitPlaceholder(unitData.data.units_management.weight.default);
          form.setFieldsValue({
            planning_weightUnit: unitData.data.units_management.weight.default,
          });
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);

          if (
            form.getFieldValue("type")?.toLowerCase() == "reel" ||
            selectedType == "reel" ||
            orderTypes.includes("reel")
          ) {
            setCoreod(
              response.default_core_id
                ? response.default_core_id + " " + response.default_core_unit
                : ""
            );
            setReelod(
              response.default_reel_od
                ? response.default_reel_od + " " + response.default_reel_unit
                : ""
            );
            form.setFieldsValue({
              reel_OD: response.default_reel_od
                ? response.default_reel_od + " " + response.default_reel_unit
                : "",
            });
            form.setFieldsValue({
              core_OD: response.default_core_id
                ? response.default_core_id + " " + response.default_core_unit
                : "",
            });
            response.default_reel_od
              ? setSelectedReelOD([
                  {
                    value:
                      response.default_reel_od +
                      " " +
                      response.default_reel_unit,
                  },
                ])
              : setSelectedReelOD([]);
          }
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const resp = await getMachineGradeSelectForConfig();
        if (!resp.error) {
          setGrain(
            resp?.data?.data?.settings.order_types[1]?.grain === "long"
              ? "Long Grain"
              : "Short Grain"
          );
          form.setFieldsValue({
            grain:
              resp?.data?.data?.settings.order_types[1]?.grain === "long"
                ? "Long Grain"
                : "Short Grain",
          });
          setMixedGrainEnabled(
            resp?.data?.data?.settings.order_types[1]?.mixed_grain
          );
          setToleranceDisabled(
            resp?.data?.data?.settings?.order_types[2]?.value
          );
          setDefaultUpperOrderTol(
            resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
              .upper_tolerance
          );
          setDefaultLowerOrderTol(
            resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
              .lower_tolerance
          );
          form.setFieldsValue({
            order_upper_tolerance:
              resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
                .upper_tolerance,
          });
          form.setFieldsValue({
            order_lower_tolerance:
              resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
                .lower_tolerance,
          });
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [props]);

  useEffect(() => {
    if (products.length === 0 && selectedPly) {
      getProducts({
        status: "active",
        type: selectedType,
        ply: selectedPly,
        isPly: true,
      })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => {
          console.log("Error in fetching products list:", error);
        });
    }
  }, [selectedType, selectedPly, props]);

  useEffect(() => {
    (async () => {
      if (selectedType) {
        try {
          const resp = await getPackagingList(selectedType, "active");
          if (!resp.error) {
            setPackagingData(resp.data);
          }
        } catch (err) {
          console.log(err);
        }
      }
    })();
  }, [selectedType]);

  useEffect(() => {
    if (
      ((selectedReelOD && selectedReelOD?.length == 1) ||
        (reelOD && orderQuantity == "reel")) &&
      coreOD &&
      widthValue
    ) {
      rewinderReelsCal();
    } else if (
      (!coreOD ||
        !selectedReelOD ||
        coreOD ||
        !selectedReelOD ||
        !coreOD ||
        selectedReelOD) &&
      selectedType == "sheet"
    ) {
      if (selectedType === "sheet" && orderQuantity === "weight") {
        if (planningWeightValue) {
          setPlannedWeight(parseFloat(planningWeightValue).toFixed(3));
          form.setFieldsValue({
            planned_weight: parseFloat(planningWeightValue).toFixed(3),
          });
        } else {
          setPlannedWeight(0.0);
          form.setFieldsValue({ planned_weight: 0 });
        }
      } else {
        let weightUnit = form.getFieldValue("weightUnit");

        let dimensionUnit = form.getFieldValue("dimensionUnit");
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = lengthValue * conversionValue;
        let width_Value = widthValue * conversionValue;

        const value =
          (length_Value *
            width_Value *
            planningQuantityValue *
            productData?.gsm) /
          (10000 * 1000000);
        let plannedWeightValue =
          value * conversionFactorTonneToUnits[unitPlaceholder];
        setPlannedWeight(
          plannedWeightValue ? plannedWeightValue.toFixed(3) : 0
        );
        form.setFieldsValue({
          planned_weight: plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0,
        });
      }
      form.setFieldsValue({ no_of_reel_sheet: 0 });
    } else {
      if (
        orderQuantity == "reel" &&
        selectedType === "reel" &&
        planningQuantityValue
      ) {
        form.setFieldsValue({ no_of_reel_sheet: planningQuantityValue });
      } else {
        form.setFieldsValue({ no_of_reel_sheet: 0 });
      }
      setRerender(true);
    }
  }, [
    widthValue,
    coreOD,
    planningWeightValue,
    planningQuantityValue,
    lengthValue,
    grainValue,
    productData,
    selectedReelOD,
    unitPlaceholder,
    widthUnit,
    reelOD,
    outerDiameter,
  ]);

  useEffect(() => {
    if (rerender) {
      plannedWeightCal();
      setRerender(false);
    }
  }, [rerender]);

  return orderTypes.length && measurementData && reelCoreData ? (
    <RightDrawerSidebar
      title="Add a new order"
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft" ref={scrollRef}>
          {visibleToaster ? (
            <AlertContainer
              setClose={setVisibleToaster}
              color={actionToaster.error ? "red toaster" : "green toaster"}
              icon={actionToaster.error ? alertRed : alertGreen}
              msg={actionToaster.msg}
              closeIcon={true}
            />
          ) : null}
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order type</h5>
                    <p>The order can be of reel or sheet type</p>
                  </div>
                  <Form.Item
                    name="type"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                    initialValue={
                      orderTypes.length ? orderTypes[0]["label"] : null
                    }
                  >
                    <Select
                      placeholder="Select"
                      suffixIcon={<DownArrowDraw />}
                      onChange={handleType}
                    >
                      {orderTypes.map((orderType) => (
                        <Option key={orderType.value}>{orderType.label}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                {!fieldBlacklist?.includes("ply") && selectedType == "reel" && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Ply Count</h5>
                      <p>Count of ply in the product to be produced</p>
                    </div>
                    <Form.Item
                      name="ply"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      initialValue={
                        plyData?.length ? plyData[0]["value"] : null
                      }
                    >
                      <Select
                        placeholder="Select Ply"
                        suffixIcon={
                          isPlyDropdownOpen ? (
                            <DropDownSearchDraw />
                          ) : (
                            <DownArrowDraw />
                          )
                        }
                        onBlur={OnPlyToggleSelect}
                        onFocus={OnPlyToggleSelect}
                        showSearch
                        optionFilterProp="children"
                        onChange={handlePlyChange}
                      >
                        {plyData.map((item) => (
                          <Option key={item.value} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product</h5>
                    <p>Product name and specifications which will define</p>
                  </div>
                  <Form.Item
                    name="product_code"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="selectForm"
                  >
                    <Select
                      placeholder="Select Product"
                      suffixIcon={
                        isProductDropdownOpen ? (
                          <DropDownSearchDraw />
                        ) : (
                          <DownArrowDraw />
                        )
                      }
                      onBlur={OnProductToggleSelect}
                      onFocus={OnProductToggleSelect}
                      showSearch
                      optionFilterProp="children"
                      onChange={handleProduct}
                    >
                      {products.map((product) => (
                        <Option key={product.code}>
                          {product.code} - {product.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <div className="titleWithText">
                    {productData ? (
                      <div style={{ marginTop: "-20px" }}>
                        <p>
                          {productData.grade +
                            " / " +
                            productData.quality +
                            (productData?.grade_parameters?.gsm ||
                            productData?.grade_parameters?.burst_factor ||
                            productData?.grade_parameters?.moisture
                              ? " / "
                              : "") +
                            (productData?.grade_parameters?.gsm
                              ? productData.gsm
                              : "") +
                            (productData?.grade_parameters?.burst_factor
                              ? " / " + productData.burst_factor
                              : "") +
                            (productData?.grade_parameters?.moisture
                              ? " / " + productData.moisture
                              : "")}
                          <Styled style={{ display: "inline-flex" }}>
                            <Tooltip
                              placement="bottomRight"
                              title={
                                "Grade: " +
                                productData.grade +
                                "\n" +
                                "Quality: " +
                                productData.quality +
                                "\n" +
                                (productData?.grade_parameters?.gsm
                                  ? "GSM: " + productData.gsm + "\n"
                                  : "") +
                                (productData?.grade_parameters?.burst_factor
                                  ? "BF: " + productData.burst_factor + "\n"
                                  : "") +
                                (productData?.grade_parameters?.moisture
                                  ? "Moisture: " + productData.moisture
                                  : "")
                              }
                              className="edit-tooltip"
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <span className="infoIcon"></span>
                            </Tooltip>
                          </Styled>
                        </p>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Size</h5>
                    <p>
                      {selectedType === "reel" ? (
                        <>The width of the order</>
                      ) : (
                        <>The width and length of the order</>
                      )}
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    {selectedType === "sheet" && (
                      <Col span={8}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label="Length"
                            name="length"
                            rules={[
                              {
                                required:
                                  selectedType === "sheet" ||
                                  orderTypes[0]?.value === "sheet"
                                    ? true
                                    : false,
                                message: "This field is required",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                              // {
                              //   pattern: new RegExp(
                              //     /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                              //   ),
                              //   message:
                              //     "Length should be a number greater than zero",
                              // },
                              {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Length should be a number greater than zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                            ]}
                            className="dBlock"
                          >
                            <Input
                              placeholder="Length"
                              onChange={(e) => {
                                onLengthChange(e);
                              }}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    )}
                    <Col span={selectedType === "sheet" ? 8 : 13}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Width"
                          name="width"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                              message:
                                "Upto 2 decimal point values is accepted",
                            },
                            // {
                            //   pattern: new RegExp(
                            //     /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            //   ),
                            //   message:
                            //     "Width should be a number greater than zero",
                            // },
                            {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Width should be a number greater than zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                          ]}
                          className="dBlock"
                        >
                          <Input
                            placeholder="Width"
                            onChange={(e) => {
                              onWidthChange(e);
                            }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={selectedType === "sheet" ? 7 : 10}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Unit"
                          name="dimensionUnit"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="dBlock"
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            onChange={onChangeWidthUnit}
                          >
                            {dimesionUnitList.map((widthUnit) => (
                              <Option key={widthUnit} value={widthUnit}>
                                {lengthUnit[widthUnit]?.displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>

                {orderTypes.length
                  ? (selectedType === "sheet" ||
                      orderTypes[0]?.value === "sheet") && (
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Grain</h5>
                          <p>The order can be of long or short grain</p>
                        </div>
                        <Form.Item
                          name="grain"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          style={{ marginBottom: 4 }}
                          initialValue={grainValue ? grainValue : null}
                        >
                          <Select
                            placeholder={"Select"}
                            suffixIcon={<DownArrowDraw />}
                            onChange={(e) => onGrainChange(e)}
                          >
                            {grainTypeData.map((grainType) => (
                              <Option key={grainType}>{grainType}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <div className="italicsTitleWithText">
                          <p>
                            {grainValue === "Long Grain"
                              ? "The shorter side will be matched in deckle matching"
                              : grainValue === "Short Grain" &&
                                "The longer side will be matched in deckle matching"}
                          </p>
                        </div>
                        <div>
                          <Row className="centerAlign justifyCSBetween">
                            <Col>
                              <Checkbox
                                style={{ borderRadius: "2px" }}
                                onChange={mixedGrainHandler}
                                checked={mixedGrain}
                                disabled={!isMixedGrainEnabled}
                              ></Checkbox>
                              <span
                                style={{
                                  marginLeft: "5px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)",
                                  lineHeight: "20px",
                                }}
                              >
                                Allow mixed grain for this order
                              </span>
                            </Col>
                          </Row>
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                          <Row className="centerAlign justifyCSBetween">
                            <Col>
                              <Checkbox
                                onChange={grainChangesHandler}
                                checked={grainChanges}
                              ></Checkbox>
                              <span
                                style={{
                                  marginLeft: "5px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)",
                                  lineHeight: "20px",
                                }}
                              >
                                Allow grain changes for this order
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )
                  : null}

                <div className="drawerField" style={{ paddingBottom: "2px" }}>
                  <div className="titleWithText">
                    <h5>Order Quantity</h5>
                    <p>Quantity of the order to be produced</p>
                  </div>
                  <div
                    className=" switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      options={orderQuantityTabArray}
                      optionType="button"
                      buttonStyle="solid"
                      value={orderQuantity}
                      onChange={handleQuantityChange}
                    />
                  </div>
                  {orderQuantity === "weight" ? (
                    <>
                      <div className="subTitleWithText">
                        <p></p>
                      </div>
                      <div style={{ position: "relative" }}>
                        <Row className="centerAlign justifyCSBetween">
                          <Col span={13}>
                            <div className="boxFormType">
                              <Form.Item
                                name="weight"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message:
                                      "Only decimal characters are allowed",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Weight should be a number greater than zero",
                                  },
                                //   {
                                //   validator(_, value) {
                                //     if (value && value == 0) {
                                //       return Promise.reject(
                                //         "Weight should be a number greater than zero"
                                //       );
                                //     } else{
                                //       return Promise.resolve();
                                //     }
                                //   },
                                // },
                                ]}
                                className="dBlock"
                              >
                                <Input
                                  placeholder="Enter weight"
                                  onChange={(e) => {
                                    handleWeight(e);
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col span={10}>
                            <div className="boxFormType ">
                              <Form.Item
                                name="weightUnit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className="dBlock"
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  onChange={onChangeWeightUnit}
                                >
                                  {weightUnitList?.map((unitItem) => (
                                    <Option key={unitItem} value={unitItem}>
                                      {weightUnit[unitItem]?.displayName}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </>
                  ) : orderQuantity === "reel" ? (
                    <>
                      <div className="subTitleWithText">
                        <p></p>
                      </div>
                      <Form.Item
                        name="quantity"
                        rules={[
                          { required: true, message: "This field is required" },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only decimal characters are allowed",
                          },
                          {
                            pattern: new RegExp(
                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            ),
                            message:
                              "Quantity should be a number greater than zero",
                          },
                          // {
                          //         validator(_, value) {
                          //           if (value && value == 0) {
                          //             return Promise.reject(
                          //               "Quantity should be a number greater than zero"
                          //             );
                          //           } else{
                          //             return Promise.resolve();
                          //           }
                          //         },
                          //       },
                        ]}
                        className=""
                      >
                        <Input
                          placeholder="Enter quantity"
                          onChange={(e) => {
                            onQuantityValueChange(e);
                            // form.setFieldsValue({
                            //   no_of_reel_sheet: e.target.value,
                            // });
                          }}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <div className="subTitleWithText">
                        <p></p>
                      </div>
                      <Form.Item
                        name="quantity"
                        rules={[
                          { required: true, message: "This field is required" },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only decimal characters are allowed",
                          },
                          {
                            pattern: new RegExp(
                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            ),
                            message:
                              "Quantity should be a number greater than zero",
                          },
                          // {
                          //         validator(_, value) {
                          //           if (value && value == 0) {
                          //             return Promise.reject(
                          //               "Quantity should be a number greater than zero"
                          //             );
                          //           } else{
                          //             return Promise.resolve();
                          //           }
                          //         },
                          //       },
                        ]}
                        className=""
                      >
                        <Input
                          placeholder="Enter quantity"
                          onChange={(e) => {
                            onQuantityValueChange(e);
                          }}
                        />
                      </Form.Item>
                    </>
                  )}
                  {orderQuantity === "weight" && isToleranceDisabled && (
                    <Collapse
                      onChange={onChangeCollpase}
                      expandIconPosition="right"
                      bordered={false}
                      style={{ backgroundColor: "white", marginTop: "-15px" }}
                    >
                      <Panel
                        header={
                          "Tolerance -" +
                          defaultLowerOrderTol +
                          " to +" +
                          defaultUpperOrderTol +
                          " %"
                        }
                        style={{ fontStyle: "italic", marginLeft: "-12px" }}
                      >
                        <Row
                          style={{ marginTop: "3px" }}
                          className="centerAlign  justifyCSBetween"
                        >
                          <Col span={8} className="blockBreak">
                            <div className="titleWithText">
                              <p
                                style={{
                                  marginTop: "7px",
                                  fontStyle: "initial",
                                  fontSize: "12px",
                                  fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)",
                                  lineHeight: "20px",
                                }}
                              >
                                Upper Tolerance{" "}
                              </p>
                            </div>
                          </Col>
                          <Col span={8} className="blockBreak">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                label=""
                                name="order_upper_tolerance"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    validator(_, value) {
                                      if (parseFloat(value) == 0) {
                                        return Promise.reject(
                                          "Min upper tolerance should be atleast 1 %"
                                        );
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  },
                                ]}
                                className="dBlock"
                              >
                                <Input
                                  placeholder=""
                                  style={{ fontSize: "10px", height: "30px" }}
                                  onChange={(e) => {
                                    onUpperTolChange(e, "order_tolerance");
                                  }}
                                />
                              </Form.Item>
                              <span
                                className="nonEditable"
                                style={{ fontSize: "13px", top: "6px" }}
                              >
                                %
                              </span>
                            </div>
                          </Col>
                          <Col span={8} className="blockBreak">
                            <Col
                              span={8}
                              className="blockBreak"
                              style={{ maxWidth: "45%", marginLeft: "15px" }}
                            >
                              <div className="titleWithText">
                                <p
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    width: "104px",
                                  }}
                                >
                                  {orderUpperTol + " "}{" "}
                                  {weightUnit[unitPlaceholder]?.displayName}
                                </p>
                              </div>
                            </Col>
                          </Col>
                        </Row>

                        <Row
                          style={{ marginTop: "0px" }}
                          className="centerAlign  justifyCSBetween"
                        >
                          <Col span={8} className="blockBreak">
                            <div className="titleWithText">
                              <p
                                style={{
                                  marginTop: "7px",
                                  fontStyle: "initial",
                                  fontSize: "12px",
                                  fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)",
                                  lineHeight: "20px",
                                }}
                              >
                                Lower Tolerance{" "}
                              </p>
                            </div>
                          </Col>
                          <Col span={8} className="blockBreak">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                label=""
                                name="order_lower_tolerance"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    validator(_, value) {
                                      if (parseFloat(value) == 0) {
                                        return Promise.reject(
                                          "Min lower tolerance should be atleast 1 %"
                                        );
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  },
                                ]}
                                className="dBlock"
                              >
                                <Input
                                  placeholder=""
                                  style={{ fontSize: "10px", height: "30px" }}
                                  onChange={(e) => {
                                    onLowerTolChange(e, "order_tolerance");
                                  }}
                                />
                              </Form.Item>
                              <span
                                className="nonEditable"
                                style={{ fontSize: "13px", top: "6px" }}
                              >
                                %
                              </span>
                            </div>
                          </Col>
                          <Col span={8} className="blockBreak">
                            <Col
                              span={8}
                              className="blockBreak"
                              style={{ maxWidth: "45%", marginLeft: "15px" }}
                            >
                              <div className="titleWithText">
                                <p
                                  style={{
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    width: "104px",
                                  }}
                                >
                                  {orderLowerTol + " "}{" "}
                                  {weightUnit[unitPlaceholder]?.displayName}
                                </p>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Panel>
                    </Collapse>
                  )}
                </div>

                {packagingData.length ? (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Packaging Details</h5>
                      <p>
                        Type of packaging to be used for this item in shipping
                      </p>
                    </div>
                    <Form.Item name="packaging_name" className="selectForm">
                      <Select
                        placeholder="Select Packaging"
                        suffixIcon={<DownArrowDraw />}
                        showSearch
                        optionFilterProp="children"
                        onChange={(e) => {
                          handlePackaging(e);
                        }}
                      >
                        {packagingData.length &&
                          packagingData?.map((item) => (
                            <Option key={item.id}>
                              {item.name} -{" "}
                              {item.quantity_type === "weight"
                                ? item.weight +
                                  " " +
                                  (item.units && item.units.weight
                                    ? capitalize(
                                        weightUnit[item.units.weight]
                                          ?.displayName
                                      )
                                    : "")
                                : item.quantity +
                                  " " +
                                  capitalize(item.type) +
                                  "s"}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                ) : (null)}

                {!fieldBlacklist?.includes("ply") && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Remarks</h5>
                      <p>Any other Information related to this quantity</p>
                    </div>
                    <Form.Item name="remarks" className="">
                      <TextArea
                        maxLength={100}
                        style={{ height: 90 }}
                        placeholder="Add Remarks"
                      />
                    </Form.Item>
                  </div>
                )}

                <div className="drawerField">
                  <Collapse
                    onChange={onChangeCollpase}
                    expandIconPosition="right"
                    bordered={false}
                    style={{
                      backgroundColor: "white",
                      marginTop: "-12px",
                      marginBottom: "-20px",
                    }}
                    className="planningDetailsCollapseIcon"
                  >
                    <Panel
                      header={
                        <div style={{ marginLeft: "-12px" }}>
                          <div className="titleWithText">
                            <h5>Planning Details</h5>
                            <p>
                              Quantity pending to be processed and associated
                              rewinder details for the quantity
                            </p>
                          </div>
                        </div>
                      }
                    >
                      <div className="titleWithText">
                        <p style={{ marginLeft: "-12px", marginTop: "-10px" }}>
                          Pending Quantity:{" "}
                          {orderQuantity === "weight"
                            ? weightValue
                              ? weightValue +
                                " " +
                                capitalize(
                                  weightUnit[unitPlaceholder]?.displayName
                                )
                              : ""
                            : quantityValue
                            ? quantityValue +
                              " " +
                              capitalize(orderQuantity) +
                              "s"
                            : ""}
                        </p>
                      </div>

                      <div
                        className="drawerField"
                        style={{ marginLeft: "-12px", marginTop: "-19px" }}
                      >
                        <div className="titleWithText">
                          <h5>Quantity to be planned</h5>
                          <p>Quantity of the order to be planned</p>
                        </div>
                        <div
                          className=" switchRadio twoSwitch"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            marginRight: "-8px",
                          }}
                        >
                          <Radio.Group
                            options={orderQuantityTabArray}
                            optionType="button"
                            buttonStyle="solid"
                            value={orderQuantity}
                            disabled={true}
                          />
                        </div>
                        {orderQuantity === "weight" ? (
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={13}>
                                  <div className="boxFormType">
                                    <Form.Item
                                      name="planning_weight"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "This value should be a non-zero positive value",
                                        },
                                        {
                                          pattern: new RegExp(
                                            /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                          ),
                                          message:
                                            "Weight should be a number greater than zero",
                                        },
                                      //   {
                                      //   validator(_, value) {
                                      //     if (value && value == 0) {
                                      //       return Promise.reject(
                                      //         "Weight should be a number greater than zero"
                                      //       );
                                      //     } else{
                                      //       return Promise.resolve();
                                      //     }
                                      //   },
                                      // },
                                      ]}
                                      className="dBlock"
                                      initialValue={weightValue}
                                    >
                                      <Input
                                        style={{ width: "185px" }}
                                        placeholder="Enter weight"
                                        onChange={(e) => {
                                          handlePlanningWeight(e);
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={10}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <Form.Item
                                      name="planning_weightUnit"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={unitPlaceholder}
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                        {weightUnitList?.map((unitItem) => (
                                          <Option
                                            key={unitItem}
                                            value={unitItem}
                                          >
                                            {weightUnit[unitItem]?.displayName}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </Col>
                                {planningWtErr ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-17px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Quantity to be planned cannot be more than
                                    the pending quantity
                                  </span>
                                ) : null}
                              </Row>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Form.Item
                                name="planning_quantity"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message:
                                      "This value should be a non-zero positive value",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Quantity should be a number greater than zero",
                                  },
                                //   {
                                //   validator(_, value) {
                                //     if (value && value == 0) {
                                //       return Promise.reject(
                                //         "Quantity should be a number greater than zero"
                                //       );
                                //     } else{
                                //       return Promise.resolve();
                                //     }
                                //   },
                                // },
                                ]}
                                className=""
                                initialValue={quantityValue}
                              >
                                <Input
                                  style={{ width: "332px" }}
                                  placeholder="Enter quantity"
                                  onChange={(e) => {
                                    onPlanningQuantityValueChange(e);
                                  }}
                                />
                              </Form.Item>
                              {planningWtErr ? (
                                <div
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-17px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Quantity to be planned cannot be more than the
                                  pending quantity
                                </div>
                              ) : null}
                            </div>
                          </>
                        )}
                      </div>

                      <div
                        className="drawerField"
                        style={{
                          borderBottom: "0px solid #edebe9",
                          marginLeft: "-12px",
                        }}
                      >
                        <div className="titleWithText">
                          <h5>Rewinder Details</h5>
                          <p>
                            The outer diameter of the reel and rewinder core
                          </p>
                        </div>

                        <div className="titleWithText">
                          <p style={{ marginLeft: "3px", marginBottom: "4px" }}>
                            Core OD
                          </p>
                          <Form.Item
                            name="core_OD"
                            rules={[]}
                            className="selectForm"
                          >
                            <Select
                              placeholder="Select Core OD"
                              suffixIcon={<DownArrowDraw />}
                              showSearch
                              optionFilterProp="children"
                              onChange={handleCoreOD}
                              style={{ width: "331px" }}
                            >
                              {coreValues?.map((data) => (
                                <Option key={data?.value}>{data?.value}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                          {coreOdValidationError ? (
                            <div
                              className="errorText"
                              style={{
                                color: "#ea4e2c",
                                marginLeft: "2px",
                                marginTop: "-22px",
                                marginBottom: "20px",
                              }}
                            >
                              Reel OD cannot be less than Core OD
                            </div>
                          ) : null}
                        </div>

                        <div
                          className=" switchRadio twoSwitch"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            marginRight: "-8px",
                          }}
                        >
                          <Radio.Group
                            options={rewinderType}
                            optionType="button"
                            buttonStyle="solid"
                            value={outerDiameter}
                            disabled={
                              selectedType == "reel" && orderQuantity == "reel"
                            }
                            onChange={handleRewinderType}
                          />
                        </div>
                        {outerDiameter === "constant" ? (
                          selectedType == "reel" && orderQuantity == "reel" ? (
                            <div className="titleWithText">
                              <p
                                style={{
                                  marginLeft: "3px",
                                  marginBottom: "4px",
                                  marginTop: "22px",
                                }}
                              >
                                Reel OD
                              </p>
                              <Form.Item
                                name="reel_OD"
                                rules={[]}
                                className="selectForm"
                              >
                                <Select
                                  placeholder="Select Reel OD"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  optionFilterProp="children"
                                  onChange={handleReelOD}
                                  style={{ width: "331px" }}
                                >
                                  {reelValues?.map((data) => (
                                    <Option key={data?.value}>
                                      {data?.value}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          ) : (
                            <div>
                              <p
                                style={{
                                  marginLeft: "3px",
                                  marginBottom: "4px",
                                  marginTop: "15px",
                                }}
                              >
                                Reel OD
                              </p>
                              <Col className="blockBreak">
                                <div className="boxFormType">
                                  <PaperMachineQualitySelect>
                                    <MultiSelectCard>
                                      <Multiselect
                                        className="multiQuality"
                                        options={reelValues}
                                        style={multiselectStyle}
                                        showArrow={true}
                                        selectedValues={selectedReelOD}
                                        displayValue={"value"}
                                        showCheckbox={true}
                                        onSelect={onChangeReelOdSelect}
                                        onRemove={onChangeReelOdSelect}
                                        hideSelectedList
                                        keepSearchTerm
                                      />
                                    </MultiSelectCard>
                                  </PaperMachineQualitySelect>
                                </div>

                                <Col span={12}>
                                  <PaperMachineGradeSelect>
                                    <div className="mainMachineGrade">
                                      {selectedReelOD &&
                                        selectedReelOD?.map((item, index) => {
                                          return (
                                            index <= 10 && (
                                              <span
                                                className={
                                                  "MachineGradeSelect-active"
                                                }
                                              >
                                                {item.value}
                                                <Button
                                                  className="textTypeBtn textBtnIcon paperButtonBg"
                                                  onClick={() => {
                                                    removeReelOD(item);
                                                  }}
                                                >
                                                  <Iconmoon
                                                    icon="wrong"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                </Button>
                                              </span>
                                            )
                                          );
                                        })}
                                    </div>
                                    {selectedReelOD &&
                                      selectedReelOD?.length > 10 &&
                                      selectedReelOD?.map((item, index) => {
                                        let tooltipData = "";
                                        for (
                                          let index = 10;
                                          index < selectedReelOD?.length;
                                          index++
                                        ) {
                                          const data = selectedReelOD[index];
                                          tooltipData =
                                            tooltipData + data.value + ", ";
                                        }
                                        tooltipData = tooltipData.substring(
                                          0,
                                          tooltipData.length - 1
                                        );
                                        return (
                                          index == 11 && (
                                            <Tooltip title={tooltipData}>
                                              {" "}
                                              <span
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                & {selectedReelOD.length - 10}{" "}
                                                More
                                              </span>
                                            </Tooltip>
                                          )
                                        );
                                      })}
                                  </PaperMachineGradeSelect>
                                </Col>
                              </Col>
                            </div>
                          )
                        ) : (
                          <div style={{ marginTop: "20px" }}>
                            <Col span={24}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={8} className="blockBreak">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label="Min Reel OD"
                                      name="min_reel_od"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only Numeric value is possible upto 3 decimal point",
                                        },
                                      ]}
                                      className="dBlock"
                                    >
                                      <Input
                                        placeholder="Min Reel OD"
                                        className={
                                          reelODValidationError
                                            ? "showErrorBorder"
                                            : ""
                                        }
                                        onChange={(e) => {
                                          onMinReelODChange(e);
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={8} className="blockBreak">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label="Max Reel OD"
                                      name="max_reel_od"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only Numeric value is possible upto 3 decimal point",
                                        },
                                      ]}
                                      className="dBlock"
                                    >
                                      <Input
                                        placeholder="Max Reel OD"
                                        className={
                                          reelODValidationError
                                            ? "showErrorBorder"
                                            : ""
                                        }
                                        onChange={(e) => {
                                          onMaxReelODChange(e);
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={7} className="blockBreak">
                                  <div className="boxFormType unitSelect">
                                    <Form.Item
                                      label="Unit"
                                      name="reelOD_unit"
                                      rules={[]}
                                      className="dBlock"
                                      style={{ width: "100px" }}
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        className="dBlock"
                                        onChange={(e) => {
                                          onRangeUnitChange(e);
                                        }}
                                      >
                                        {measurementData?.data.units_management.length.data?.map(
                                          (reelUnit) => (
                                            <Option
                                              key={reelUnit}
                                              value={reelUnit}
                                            >
                                              {
                                                lengthUnit[reelUnit]
                                                  ?.displayName
                                              }
                                            </Option>
                                          )
                                        )}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </Col>
                                {reelODValidationError ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-2px",
                                    }}
                                  >
                                    Max dia cannot be less than Min dia
                                  </span>
                                ) : null}
                                {rangeValidationError ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-2px",
                                    }}
                                  >
                                    Min Reel dia cannot be less than Core OD
                                  </span>
                                ) : null}
                              </Row>
                            </Col>
                          </div>
                        )}
                        {((selectedReelOD && selectedReelOD?.length == 1) ||
                          (reelOD &&
                            orderQuantity == "reel" &&
                            selectedType == "reel")) &&
                        outerDiameter !== "range" ? (
                          <div>
                            {orderQuantity != "reel" && (
                              <div className="titleWithText">
                                <h5
                                  style={{
                                    color: "#ea655b",
                                    marginTop: "10px",
                                  }}
                                >
                                  Calculated number of reels on specified Core{" "}
                                </h5>
                                <h5
                                  style={{
                                    color: "#ea655b",
                                    marginTop: "5px",
                                  }}
                                >
                                  OD & Reel OD: {plannedReels}
                                </h5>
                              </div>
                            )}
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={10}>
                                <div className="boxFormType">
                                  <p
                                    style={{
                                      marginBottom: "3px",
                                      marginTop: "12px",
                                    }}
                                  >
                                    Rewinder Reels
                                  </p>
                                  <Form.Item
                                    name="no_of_reel_sheet"
                                    rules={[
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only numeric characters upto 3 decimal points are allowed",
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Enter the number of reels"
                                      disabled={
                                        orderQuantity == "reel" &&
                                        selectedType == "reel"
                                      }
                                      onChange={(e) => {
                                        onPlannedReelsChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={13}>
                                <div className="boxFormType">
                                  <p
                                    style={{
                                      marginBottom: "3px",
                                      marginTop: "12px",
                                    }}
                                  >
                                    Planned Weight
                                  </p>
                                  <Form.Item
                                    name="planned_weight"
                                    rules={[]}
                                    className=""
                                  >
                                    <Input
                                      style={{ width: "185px" }}
                                      disabled
                                    />
                                  </Form.Item>
                                  <div
                                    style={{
                                      marginTop: "-57px",
                                      marginLeft:
                                        weightUnit[unitPlaceholder]
                                          ?.displayName == "US - Ton"
                                          ? "116px"
                                          : weightUnit[unitPlaceholder]
                                              ?.displayName == "ton" ||
                                            weightUnit[unitPlaceholder]
                                              ?.displayName == "kg"
                                          ? "152px"
                                          : "168px",
                                      position: "relative",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "#a19f9d",
                                    }}
                                  >
                                    {weightUnit[unitPlaceholder]?.displayName}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ) : null}
                        <div></div>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn"
                      onClick={() => setAdd(false)}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Add Order{" "}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="themeBtn noBg"
                      htmlType="submit"
                      onClick={() => setAdd(true)}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                      Add & create a new order{" "}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};
export default AddDummyOrderDrawer;